import type { CoveredAmount } from './types';

export type LppMapping = 'mapped' | 'unmapped' | 'unavailable';

export function lppMappingStatus(offerId: unknown): LppMapping {
  if (offerId === null || offerId === '') return 'unmapped';
  return typeof offerId === 'string' && offerId.trim() ? 'mapped' : 'unavailable';
}

/** Source row counts distinguish an empty extraction from missing financial values. */
export function lppMarginPresentation(mapping: LppMapping, amount?: CoveredAmount) {
  if (mapping === 'unmapped') {
    return { kind: 'unmapped', value: null, caption: 'No LPP mapping in this snapshot' } as const;
  }
  if (mapping === 'unavailable') {
    return { kind: 'unavailable', value: null, caption: 'LPP mapping could not be verified' } as const;
  }
  if (amount?.source_rows === 0) {
    return { kind: 'no_records', value: null, caption: 'No recorded sales in this period' } as const;
  }
  const value = amount?.value ?? amount?.observed_subtotal;
  if (typeof value !== 'number' || !Number.isFinite(value)) {
    return { kind: 'unavailable', value: null, caption: 'Figures unavailable' } as const;
  }
  if (amount?.value == null) {
    return { kind: 'partial', value, caption: 'Observed subtotal · incomplete financial records' } as const;
  }
  return value === 0
    ? ({ kind: 'zero', value, caption: 'Recorded zero margin' } as const)
    : ({ kind: 'observed', value, caption: 'Recorded margin' } as const);
}
